import { Component, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { BreadcrumbService } from '../../breadcrumb.service';
import { ReportDefinition } from '../domain/reportdefinition';
import { ReportDefinitionService } from '../service/reportdefinition.service';
import { CompanyService } from '../service/company.service';
import { MenuItem, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthGuardService } from '../service/authguardservice';
import { Configuration } from '../domain/configuration';
import { Company } from '../domain/company';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
    templateUrl: './reportdefinition-table.component.html',
    styles: [
        `
            .ui-dataview-layout-options .ui-button {
                margin-left: 0.5em;
            }
            .ui-dataview .filter-container {
                text-align: center;
            }

            .title-container {
                padding: 1em;
                text-align: right;
            }

            .sort-container {
                text-align: left;
            }

            @keyframes pulse {
                0% {
                    background-color: rgba(165, 165, 165, 0.1);
                }
                50% {
                    background-color: rgba(165, 165, 165, 0.3);
                }
                100% {
                    background-color: rgba(165, 165, 165, 0.1);
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None
})
export class ReportDefinitionTableComponent implements OnInit {

    cols: any[];

    objects: ReportDefinition[];

    objectsforSearch: ReportDefinition[];

    reports: ReportDefinition[];

    selected: ReportDefinition;

    sortKey: string;

    sortField: string;

    sortOrder: number;

    timeout: any;

    items: MenuItem[];

    company: Company;

    userName: string;

    displayExecutor: boolean;

    procedureName: string;
    storedProcedureStatus: string;
    executingStoredProcedure: boolean = false;
    executedStoredProcedure: boolean = false;

    processReportsStatus: string;
    executingProcessReports: boolean = false;
    executedProcessReports: boolean = false;
    companyCode: string;
    reportCode: string;

    companies: Company[];

    constructor(
        private breadcrumbService: BreadcrumbService,
        private reportDefinitionService: ReportDefinitionService,
        private messageService: MessageService,
        private router: Router,
        private authGuard: AuthGuardService,
        private jwtHelper : JwtHelperService,
        private companyService: CompanyService , 
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = function() {
            return false;
        };

        this.breadcrumbService.setItems([
            { label: 'Report Definitions', routerLink: ['/reportdefinitions'] }
        ]);

        companyService.get().then(objects => this.companies = objects).then(() => {

        });


    }

    ngOnInit() {

        console.log()
        this.company = JSON.parse(
            localStorage.getItem('currentCompany')
        );

        
        this.companyCode = this.company.name;
        this.company.name = this.companyCode;

        this.userName = this.getUserName();

        this.cols = [
            { field: 'Id', header: 'Id' },
            { field: 'Name', header: 'Name' },
            { field: 'Description', header: 'Description' },
            { field: 'ReportPreviewLink', header: 'Report Preview Link' },
            { field: 'Dimension1', header: 'Dimension 1' },
            { field: 'Dimension2', header: 'Dimension 2' },
            { field: 'Dimension3', header: 'Dimension 3' },
            { field: 'Dimension4', header: 'Dimension 4' }
        ];

        this.reportDefinitionService.get(JSON.parse(localStorage.getItem('currentCompany')).id).then(objects => this.objects = objects).then(()=> {

            console.log(this.objects);
        }
           
        );
       

        this.items = [
            {
                label: 'View',
                icon: 'pi pi-search',
                command: event => this.viewReportDefinition(this.selected)
            },
            {
                label: 'Delete',
                icon: 'pi pi-times',
                command: event => this.deleteReportDefinition(this.selected)
            }
        ];
    }

    viewReportDefinition(definition: ReportDefinition) {
        this.router.navigate(['/reportdefinitions', definition.Id]);
    }

    duplicateReportDefinition(definition: ReportDefinition) {
        this.reportDefinitionService.clone(definition.Id)
                                    .then(newid => {
                                        this.reportDefinitionService.get(
                                            JSON.parse(localStorage.getItem('currentCompany')).id)
                                        .then(objects => (this.objects = objects)
                                    ); } );
    }

    deleteReportDefinition(definition: ReportDefinition) {
        this.reportDefinitionService.delete(`${definition.Id}`).then(l => {
            this.reportDefinitionService.get(1).then(
                objects => (this.objects = objects)
            )
            this.messageService.add({
                severity: 'info',
                summary: 'ReportDefinition deleted',
                detail: definition.Id + ' - ' + definition.Name
            });

        });
    }

    addClick() {
        this.router.navigate(['/reportdefinitions', 'new']);
    }

    execute() {
        console.log("Execute")
        this.displayExecutor = false;

        const ids = [];
        this.reports.forEach(element => {
            ids.push(element.Id);
        });
        this.reportDefinitionService.execute(ids)
        .then(def => {this.messageService.add({
            severity: 'info',
            summary: 'Batch execution started ... ',
            detail: 'You will be noticed by e-mail...'
        });});
    }

    executeStoredProcedure()
    {
        this.executingStoredProcedure = true;
        this.storedProcedureStatus = "Stored procedure " + this.procedureName + " is being executed...";

        this.reportDefinitionService.executeStoredProcedure(this.procedureName)
        .then(() => {
            this.storedProcedureStatus = "Stored procedure " + this.procedureName + " executed successfully.";
            this.executedStoredProcedure = true;
        }).catch(response => {
            this.storedProcedureStatus = "Stored procedure " + this.procedureName + " failed to execute: " + response.error.title + ".";
            this.executedStoredProcedure = true;
        });
    }

    executeProcessReports_old()
    {
        this.executingProcessReports = true;
        this.processReportsStatus = "Processing report...";

        this.reportDefinitionService.executeProcessReports(this.companyCode, this.reportCode)
        .then((data) => {
            console.log(data);
            this.processReportsStatus = "Executed successfully.";
            this.executedProcessReports = true;
        }).catch(response => {
            console.log(response);
            if (response.error)
            {
                this.processReportsStatus = "Failed to execute: " + response.error.title + ".";
            }
            else 
            {
                this.processReportsStatus = "Failed to execute: undefined error.";
            }
            this.executedProcessReports = true;
        });
    }

    executeProcessReports()
    {
        this.companyCode = this.company.name;
        console.log("this.companyCode");
        console.log(this.companyCode);
        this.processReportsStatus = "Processing report...";

        this.reportDefinitionService.executeProcessReports(this.companyCode, this.reportCode)
        .then((data) => {
            console.log(data);
            this.processReportsStatus = "Executed successfully.";
           
        }).catch(response => {
            console.log(response);
            if (response.error)
            {
                this.processReportsStatus = "Failed to execute: " + response.error.title + ".";
            }
            else 
            {
                this.processReportsStatus = "Failed to execute: undefined error.";
            }
          
        });
    }

    executeClick_old() {
        this.displayExecutor = true;
    }

    executeClick() {
  
  if (confirm("Do you want to start processing the reports?") == true) {
    this.executeProcessReports();
  } else {

  }

    }

    onSortChange(event) {
        const value = event.value;

        if (value.indexOf('!') === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

    getReportPicture(item: any) {
        return Configuration.server + '/api/report/' + item.Id + '/image';
    }

    getUserName(){
        const token = this.jwtHelper.decodeToken(localStorage.getItem('jwt'));

        return  token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'] + ' '
                 + token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'];
    }

    search(event) {
        this.reportDefinitionService.get(JSON.parse(localStorage.getItem('currentCompany')).id).then(
            objects => (this.objectsforSearch = objects)
        );
    }



}
